import { render } from "./Admin.vue?vue&type=template&id=d515602e"
import script from "./Admin.vue?vue&type=script&lang=js"
export * from "./Admin.vue?vue&type=script&lang=js"
script.render = render

export default script